import { useCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const wireUseCanvasTopOffset = WrappedComponent => props => {
  const canvasTopOffset = useCanvasTopOffset(props.canvasScrollElementRef);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    canvasTopOffset: canvasTopOffset
  }));
};